import {
  Box,
  Chip,
  Modal,
  Paper,
  Typography,
  IconButton,
  lighten,
  darken,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TerminalOutlined } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";

export default function HostsModal({
  open,
  onClose,
  title = "Hosts",
  hosts = [],
  interfaces,
  color,
  onNavigate,
  enableRemoteAccess,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          ...styles.modalPaper,
          borderTopColor: color,
        }}
      >
        <Box sx={styles.modalBox}>
          <Typography sx={{ ...styles.modalTitle, backgroundColor: color }}>
            {title}
          </Typography>
          <Box
            onClick={onClose}
            size="small"
            sx={{
              ...styles.modalButton,
              borderColor: color,
            }}
          >
            <CloseIcon />
          </Box>
        </Box>

        <Box sx={styles.modalContent}>
          {interfaces?.length > 0
            ? interfaces?.map((host, index) => {
                const ifaceName =
                  typeof host === "string" ? host : host?.interface;
                const ifaceTags =
                  typeof host === "string" ? [] : (host?.tags ?? []);
                return (
                  <Box
                    key={index}
                    sx={{
                      backgroundColor:
                        index % 2 == 0 &&
                        (theme.palette.mode == "dark"
                          ? lighten(theme.palette.background.paper, 0.08)
                          : darken(theme.palette.background.paper, 0.08)),
                      borderRadius: "4px",
                      gap: 0,
                      p: 1,
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        ...styles.modalStatusBall,
                        backgroundColor: `${color}70`,
                      }}
                    >
                      <Box
                        sx={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          backgroundColor: color,
                        }}
                      />
                    </Box>
                    <Typography sx={{ fontSize: "14px" }}>
                      {ifaceName}
                    </Typography>
                    {ifaceTags.map((tag) => (
                      <Chip
                        key={tag?.id}
                        size="small"
                        label={tag?.tagName}
                        sx={{
                          height: 18,
                          ml: 0.5,
                          bgcolor: tag?.colorTag,
                          color: theme.palette.colors?.white?.lighter || "#fff",
                        }}
                      />
                    ))}
                  </Box>
                );
              })
            : hosts?.map((host, index) => (
                <Box
                  sx={{
                    backgroundColor:
                      index % 2 == 0 &&
                      (theme.palette.mode == "dark"
                        ? lighten(theme.palette.background.paper, 0.08)
                        : darken(theme.palette.background.paper, 0.08)),
                    borderRadius: "4px",
                    gap: 0,
                    p: 1,
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      ...styles.modalStatusBall,
                      backgroundColor: `${color}70`,
                    }}
                  >
                    <Box
                      sx={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: color,
                      }}
                    />
                  </Box>
                  <Typography key={host.id} sx={{ fontSize: "14px" }}>
                    {host.host}
                  </Typography>
                  {enableRemoteAccess && host?.hostId && (
                    <Tooltip title="Acesso Remoto" placement="top">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onNavigate) onNavigate(host.hostId);
                        }}
                        sx={{ ml: "auto", p: 0.5 }}
                      >
                        <TerminalOutlined fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              ))}
        </Box>
      </Paper>
    </Modal>
  );
}
